import jwtDecode from 'jwt-decode';

class AdvisorAuth {

    setJWTToken(auth0ResponseData) {
        localStorage.setItem('advisor_token', auth0ResponseData.accessToken);
        localStorage.setItem('advisor_expires_at', new Date().getTime() + auth0ResponseData.expiryIn * 1000);
    }

    loadJWTToken() {
        const token = localStorage.getItem('advisor_token');
        return (token !== null && typeof token !== 'udnefined');
    }

    getJWTToken() {
        return localStorage.getItem('advisor_token');
    }

    clearTokenFromLocalStorage() {
        localStorage.removeItem('advisor_token');
        localStorage.removeItem('advisor_expires_at');
    }

    getExpirationTimeFromToken(token) {
        const decodedToken = jwtDecode(token);
        return decodedToken.exp;
    }

    isAdvisorAuthenticated() {
        let expiresAt = JSON.parse(localStorage.getItem('advisor_expires_at'));
        if (new Date().getTime() < expiresAt) {
            return this.loadJWTToken();
        }

        return false;
    }

    getInstitute() {
        return localStorage.getItem('advisor_institute');
    }

    setInstitute(institute) {
        localStorage.setItem('advisor_institute', institute);
    }
}

export default new AdvisorAuth();


// WEBPACK FOOTER //
// ./src/services/AdvisorAuth.js